(function () {
  const questions = document.querySelectorAll(".faq-question");
  questions.forEach((question) => {
    question.addEventListener("click", handleQuestionClick);
  });
  function handleQuestionClick() {
    const parent = this.parentElement;
    const answer = parent.querySelector(".faq-answer");
    if (answer.classList.contains("opened")) {
      answer.classList.remove("opened");
      answer.style.height = 0 + "px";
      return;
    }
    const openedAnswer = document.querySelector(".faq-answer.opened");

    if (openedAnswer) {
      openedAnswer.classList.remove("opened");
      openedAnswer.style.height = 0 + "px";
    }
    answer.classList.add("opened");
    answer.style.height = answer.scrollHeight + "px";
  }

  function close(params) {}
})();
